import { useRootStore } from '@hooks/useRootStore';
import { Button, Typography } from '@mui/material';
import { Box } from '@mui/system';
import React from 'react';
import { useNavigate } from 'react-router-dom';

interface OrderConfirmedStatusInfoProps {
    closeOrderCartDrawer: () => void;
}

const OrderConfirmedStatusInfo: React.FC<OrderConfirmedStatusInfoProps> = ({ closeOrderCartDrawer }) => {
    const navigate = useNavigate();
    const { authorizationStore } = useRootStore();
    const { user } = authorizationStore;

    const handleOnMyOrdersClick = () => {
        closeOrderCartDrawer();
        navigate(`/user-settings/${user?.id}/my-orders`);
    }

    return (
        <Box display={"flex"} flexDirection={"column"} alignItems={"center"} gap={1.5}>
            <Typography fontWeight={600}>Hvala na narudžbi!</Typography>
            <Typography>Tvoja narudžba je prihvaćena.</Typography>

            <Button
                sx={{ mt: 2 }}
                color='secondary'
                variant='outlined'
                onClick={handleOnMyOrdersClick}>
                Moje narudžbe
            </Button>
        </Box>
    )
}

export default OrderConfirmedStatusInfo;